import React from 'react';
import {ImSpinner2} from 'react-icons/im';
import {
    MdImageSearch,
    MdArticle,
    MdOpenInBrowser,
    MdTouchApp,
    MdTab,
    MdSmartToy
} from 'react-icons/md';
import {VoiceActivityIcon, VoiceActivityState} from './voiceActivity';

const activityIcons: Record<VoiceActivityIcon, React.ComponentType> = {
    look: MdImageSearch,
    page: MdArticle,
    navigate: MdOpenInBrowser,
    act: MdTouchApp,
    tabs: MdTab,
    assistant: MdSmartToy
};

const noPointer: React.CSSProperties = {pointerEvents: 'none'};

/**
 * One line in the voice panel naming the action running right now, so a look
 * at the page or a message to the assistant is visible while it happens.
 * `role="status"` announces it to screen readers without stealing focus.
 */
const VoiceActivityIndicator: React.FC<{
    activity: VoiceActivityState;
    className?: string;
}> = ({activity, className}) => {
    const Icon = activity.icon ? activityIcons[activity.icon] : null;

    return (
        <div
            role="status"
            className={`small d-flex align-items-center gap-2 ${className ?? ''}`.trim()}
        >
            <ImSpinner2
                className="voice-assistant-control__spinner"
                style={noPointer}
                aria-hidden="true"
            />
            {Icon && (
                <span aria-hidden="true" style={noPointer}>
                    <Icon />
                </span>
            )}
            <span>{activity.label}</span>
        </div>
    );
};

export default VoiceActivityIndicator;
